import { render, staticRenderFns } from "./CodeAndPin.vue?vue&type=template&id=3decd984&scoped=true&"
import script from "./CodeAndPin.vue?vue&type=script&lang=js&"
export * from "./CodeAndPin.vue?vue&type=script&lang=js&"
import style0 from "./CodeAndPin.vue?vue&type=style&index=0&id=3decd984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3decd984",
  null
  
)

export default component.exports